var Backbone = require("../../libs/backbone/backbone");
var GenericModel = require("./generic.model.ts");

var CountersModel = GenericModel.extend(
{
    urlRoot : '/rest/api/counters',
    id : null,
    queueId : "",
    agentId : "",
    status : "",

});

module.exports = CountersModel;